const Config = Object.freeze({
  baseUrl: "https://api.baharabrand.com/v1",
});

export default Config;
